/**
 * RateLimiter - simple sliding window limit
 *
 * Prevents spamming the backend if a SPA adds many scripts in a short time.
 */
export class RateLimiter {
	constructor(maxPerMinute = 30) {
		this.maxPerMinute = Math.max(1, Number(maxPerMinute) || 30);
		this.timestamps = [];
	}

	canReport(now = Date.now()) {
		this.cleanup(now);
		return this.timestamps.length < this.maxPerMinute;
	}

	record(now = Date.now()) {
		this.cleanup(now);
		this.timestamps.push(now);
	}

	cleanup(now = Date.now()) {
		const cutoff = now - 60_000;
		while (this.timestamps.length && this.timestamps[0] < cutoff) {
			this.timestamps.shift();
		}
	}
}

export default RateLimiter;

